import moment from 'moment';
import {
  TEACHER_PERFORMANCE_STATES,
  RETENTION_STATUS_CONFIG,
} from 'constants/teacher-details';

export const retentionHistoryImportMapper = (data = {}) => {
  // this mapper is to convert the response from /retention-history api into the format to be used in FE
  const {
    current_month: month,
    cycle,
    performance_state: performanceState,
    retention_rate: retentionRate,
    retention_summary: retentionSummary,
    retention_formula: retentionFormula,
    students,
    eligibility_criteria: eligibilityCriteria,
  } = data ?? {};
  const mappedStudents =
    students?.map(
      ({
        name,
        grade,
        region,
        enrollment_type: enrollmentType,
        status,
        last_class_on: lastClassOn,
        classes_count: classesCount,
        comment,
        id,
        gender,
      }) => ({
        id,
        name,
        grade,
        region,
        enrollmentType,
        gender,
        status,
        lastClassOn: lastClassOn
          ? moment.unix?.(Number(lastClassOn))?.format('DD MMM, YYYY')
          : '--',
        classesCount,
        comment,
        statusLabel: RETENTION_STATUS_CONFIG?.[status]?.label,
      }),
    ) || [];

  const mappedRetentionSummary = retentionSummary?.map(({ is_bold_label, ...rest }) => ({
    ...rest,
    isBold: !!is_bold_label,
  }));

  return {
    cycle,
    month,
    performanceState:
      performanceState === ''
        ? TEACHER_PERFORMANCE_STATES.NOT_CONSIDERED
        : performanceState,
    retentionRate,
    retentionSummary: mappedRetentionSummary,
    retentionFormula,
    students: mappedStudents,
    eligibilityCriteria,
  };
};
